module.exports = __webpack_public_path__ + "media/packs/images/flags/DO-c8c63960a7a39c30b1b98cb3208d0032.svg";